import { EnvironmentProviders, makeEnvironmentProviders } from '@angular/core';
import { SupportServiceConfig } from './support-service.types';

export function provideSupportService(config: SupportServiceConfig): EnvironmentProviders {
  return makeEnvironmentProviders([
    { provide: 'supportServiceConfig', useValue: config }
  ]);
}
